/**
 * Scroll Reveal Engine
 * Uses IntersectionObserver to trigger animations when elements enter the viewport.
 */
(function() {
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -5% 0px', // Trigger when element is 5% from the bottom
    threshold: 0.01 // Trigger as soon as a single pixel enters
  };

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        // Once the animation is triggered, we can stop observing this specific element
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const initReveal = () => {
    const revealElements = document.querySelectorAll('.reveal-slide-up, .reveal-fade-in, .reveal-scale-up, .reveal-ball-expand, .reveal-fade-in-up, .table-reveal, [data-reveal-stagger] > *');
    revealElements.forEach(el => revealObserver.observe(el));
  };

  // Initialize on DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Also re-initialize when Shopify section is loaded in theme editor
  document.addEventListener('shopify:section:load', initReveal);
})();

/**
 * Phase 5 (Horizon port, live parity): on desktop Horizon scrolls inside
 * .page-wrapper, so its scroll events never reach document/window. The legacy
 * sections (featured-banner, hero-banner, collage, collage-images, quick-steps)
 * listen on window/document as on live; forward the wrapper's scroll to them.
 */
(function() {
  const bridge = () => {
    const wrapper = document.querySelector('.page-wrapper');
    if (!wrapper || wrapper.dataset.csimScrollBridge) return;
    wrapper.dataset.csimScrollBridge = 'true';
    wrapper.addEventListener('scroll', () => {
      document.dispatchEvent(new Event('scroll', { bubbles: true }));
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bridge);
  } else {
    bridge();
  }
})();
